/*
 * Copyright (c) 2023. Designed and built by Zachary Berridge.
 */
import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function() {
    let slick_carousel = document.querySelector('.slick-carousel-container')
    let show_controls = slick_carousel.dataset.controls
    if(show_controls === 'true'){
        show_controls = true
    } else {
        show_controls = false
    }
    $('.slick-carousel .slider-outer').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: show_controls,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true
    });
})